import { Vec2Like } from "./vec-like";

export function angleABC(a:Vec2Like, b:Vec2Like, c:Vec2Like){
	var ab = Math.sqrt((b.x-a.x)**2+(b.y-a.y)**2);    
	var bc = Math.sqrt((b.x-c.x)**2+(b.y-c.y)**2); 
	var ac = Math.sqrt((c.x-a.x)**2+(c.y-a.y)**2);
	return Math.acos((bc*bc+ab*ab-ac*ac)/(2*bc*ab));
}